"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mosaicUrl = void 0;
/**
 * See here for Mosaic reference: https://github.com/Chewy-Inc/mosaic#operations
 *
 */
function mosaicUrl(url, size) {
    const [prefix, suffix] = url.split(',');
    // next/image doesn't like protocol relative urls
    const fixedPrefix = prefix.startsWith('//') ? `https:${prefix}` : prefix;
    return `${fixedPrefix}._AC_SS${size}_V${suffix}_.jpg`;
}
exports.mosaicUrl = mosaicUrl;
//# sourceMappingURL=mosaic.js.map